import React from 'react';
export function GuaranteeSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-79">
      <div className="bg-[var(--card)] border border-[var(--border)] rounded-[20px] p-8 text-center" data-id="element-80">
        <div className="text-[56px] mb-4" data-id="element-81">🛡️</div>

        <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-82">
          Garantía de <span className="text-[var(--accent)]" data-id="element-83">30 días</span>
        </h2>

        <div className="h-[3px] w-10 bg-[var(--accent)] mx-auto mt-3.5 mb-0" data-id="element-84" />

        <p className="text-[var(--muted)] text-[15px] leading-relaxed mt-3.5" data-id="element-85">
          Si aplicaste el sistema en tus primeras 3 citas y sientes que no te
          dio claridad, te devolvemos el 100% de tu dinero sin preguntas, sin
          formularios complicados, sin drama. El riesgo es nuestro, no tuyo.
        </p>
      </div>
    </section>;
}